var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE164"
    },
    d: "M174,327c0,0-38,25-38,55c0,25,0,122,0,122l88-88L174,327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE164"
    },
    d: "M338,327c0,0,38,25,38,55c0,25,0,122,0,122l-88-88L338,327z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M344.826,160c-8.021-37.25-22.474-71.23-41.782-100C289.556,39.903,273.701,22.344,256,8 c-17.7,14.344-33.555,31.902-47.044,52c-19.309,28.77-33.761,62.75-41.782,100c-4.67,21.69-7.174,44.48-7.174,68 c0,92.135,38.208,173.168,96,220c57.792-46.832,96-127.865,96-220C352,204.48,349.496,181.69,344.826,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M256,8c-17.7,14.344-33.555,31.902-47.044,52h94.087C289.556,39.903,273.701,22.344,256,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M344.826,160c-8.021-37.25-22.474-71.23-41.782-100h-94.087c-19.309,28.77-33.761,62.75-41.782,100 H344.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M191,228c0-23.521,2.504-46.311,7.174-68h-31c-4.67,21.69-7.174,44.48-7.174,68 c0,92.135,38.208,173.168,96,220c5.34-4.327,10.509-8.95,15.5-13.843C222.477,386.095,191,311.622,191,228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M271.5,21.848C266.51,16.953,261.34,12.328,256,8c-17.7,14.344-33.555,31.902-47.044,52h31 C249.375,45.966,259.951,33.176,271.5,21.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2555A"
    },
    d: "M239.956,60h-31c-19.309,28.77-33.761,62.75-41.782,100h31C206.195,122.75,220.648,88.771,239.956,60 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5B5D6E"
    },
    cx: 256,
    cy: 160,
    r: 39
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,208c-26.467,0-48-21.533-48-48s21.533-48,48-48c5.668,0,11.219,0.981,16.5,2.914c4.149,1.519,6.281,6.114,4.762,10.263 c-1.519,4.148-6.113,6.28-10.263,4.762C263.486,128.653,259.785,128,256,128c-17.645,0-32,14.355-32,32s14.355,32,32,32 s32-14.355,32-32c0-3.423-0.536-6.789-1.592-10.002c-1.379-4.198,0.905-8.719,5.102-10.098c4.196-1.377,8.719,0.905,10.098,5.102 C303.195,149.831,304,154.877,304,160C304,186.468,282.467,208,256,208z M384,382v122c0,3.235-1.949,6.152-4.939,7.391 c-0.99,0.41-2.029,0.609-3.06,0.609c-2.083,0-4.128-0.813-5.659-2.343l-81.789-81.79c-7.648,8.595-15.853,16.563-24.554,23.864V503 c0,4.418-3.582,8-8,8c-4.419,0-8-3.582-8-8v-51.268c-8.701-7.301-16.906-15.27-24.554-23.864l-81.789,81.79 c-1.53,1.53-3.577,2.343-5.659,2.343c-1.03,0-2.07-0.199-3.059-0.609C129.949,510.153,128,507.236,128,504V382 c0-28.24,27.65-51.431,37.896-59.055C156.836,293.046,152,260.976,152,228c0-91.433,36.996-175.999,98.963-226.215 c2.936-2.38,7.138-2.38,10.073,0C323.005,52.001,360,136.568,360,228c0,32.975-4.836,65.045-13.896,94.945 C356.35,330.569,384,353.761,384,382z M213.167,415.52c-17.514-22.436-31.645-48.308-41.898-76.447 C161.191,347.327,144,364.036,144,382v102.687L213.167,415.52z M280.985,412.162c0.357-0.652,0.806-1.266,1.358-1.818 c0.175-0.175,0.358-0.337,0.545-0.492C321.684,362.437,344,297.387,344,228c0-84.128-32.782-161.908-88-209.571 C200.782,66.092,168,143.872,168,228c0,69.386,22.317,134.436,61.112,181.851c0.187,0.155,0.37,0.317,0.545,0.492 c0.552,0.552,1.001,1.166,1.358,1.818c5.36,6.383,11.031,12.424,16.985,18.109V328c0-4.418,3.582-8,8-8s8,3.582,8,8v102.271 C269.955,424.586,275.625,418.544,280.985,412.162z M368,382c0-16.912-15.989-33.738-27.25-42.98 c-10.255,28.159-24.392,54.049-41.917,76.499L368,484.687V382z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIc);
export default __webpack_public_path__ + "static/media/logo-ic.5e3ef487a433956bfd5e2fd0756c63fa.svg";
export { ForwardRef as ReactComponent };